import { Box, Divider, Grid, Typography } from '@atgfr8/atg-ui-tailwind';

import cls from './classes';

export const LineItemsLockedModel = () => {
  return (
    <Box>
      <Grid container spacing={4} class="px-2 pb-4 items-center">
        <Grid item size={12} class="text-center">
          <Typography class={cls.postLoadText} variant="h6" component="h2">
            Why Can’t I Edit My Line Items?
          </Typography>
        </Grid>
      </Grid>
      <Divider class={cls.divider} />
      <Grid container rowSpacing={2}>
        <Grid item size={12} class="mt-2">
          <span class={cls.lockedText}>
            This is not a glitch. Your Line Items have been locked because one
            or more of your Loads have been Processed and written to our
            accounting books. At this time, change to existing line items can no
            longer be made.
          </span>
        </Grid>
        <Grid item size={12}>
          <span class={cls.lockedText}>
            You can add new Line Items to show any adjustment to the rate, but
            you cannot change existing Line Items.
          </span>
        </Grid>
      </Grid>
    </Box>
  );
};
